import blankTable from './src/BlankTable.vue'

export default blankTable
